document.addEventListener('DOMContentLoaded', function () {
    const dismissedKey = "de-redirect-dismissed";

    if (location.hostname.startsWith("de.")) {
        return;
    }

    const botPattern = /googlebot|bingbot|yandex|baiduspider|duckduckbot|slurp|facebookexternalhit|twitterbot/i;
    if (botPattern.test(navigator.userAgent)) {
        return;
    }

    if (localStorage.getItem(dismissedKey) === "true") {
        return;
    }

    const browserLanguage = (navigator.language || navigator.languages?.[0] || "").toLowerCase();
    if (!browserLanguage.startsWith("de")) {
        return;
    }

    const targetUrl = "https://de.rasotec.com" + location.pathname + location.search;

    const overlay = document.createElement("div");
    overlay.className = "popup-overlay displayflex";
    overlay.id = "deRedirectOverlay";

    const popup = document.createElement("div");
    popup.className = "popup";
    popup.innerHTML = `
        <h2>Deutsche Version verf&uuml;gbar</h2>
        <p>Es sieht so aus, als bevorzugen Sie Deutsch. M&ouml;chten Sie zur deutschen Version von rasotec wechseln?</p>
    `;

    const switchButton = document.createElement("div");
    switchButton.className = "button";
    switchButton.id = "deRedirectSwitch";
    switchButton.innerHTML = "<p><a>Zur deutschen Seite</a></p>";

    const stayButton = document.createElement("div");
    stayButton.className = "button";
    stayButton.id = "deRedirectStay";
    stayButton.innerHTML = "<p><a>Auf Englisch bleiben</a></p>";

    switchButton.addEventListener("click", () => {
        localStorage.setItem(dismissedKey, "false");
        location.href = targetUrl;
    });

    stayButton.addEventListener("click", () => {
        localStorage.setItem(dismissedKey, "true");
        overlay.remove();
        document.body.style.overflow = "";
    });

    popup.appendChild(switchButton);
    popup.appendChild(stayButton);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";
});
